import api from './api'
import { ConviteEmitido } from '@/types/candidatura'
import { ConviteDiretoRequest, ConvitePendente } from '@/types/convite'

const CANDIDATURAS_URL = '/api/v1/candidaturas'
const CONVITES_URL = '/api/v1/convites'

/**
 * Convite direto do administrador (Onda 7.3, gate C4): a candidatura pública continua
 * existindo; isto é o atalho ao lado dela — cria a candidatura já aprovada e emite o
 * convite no mesmo passo. A lista de pendentes é a fonte do KPI "Convites pendentes".
 */
export const convitesService = {
  convidar: async (request: ConviteDiretoRequest): Promise<ConviteEmitido> => {
    const r = await api.post<ConviteEmitido>(`${CANDIDATURAS_URL}/convite-direto`, request)
    return r as unknown as ConviteEmitido
  },

  listarPendentes: async (): Promise<ConvitePendente[]> => {
    const r = await api.get<ConvitePendente[]>(`${CANDIDATURAS_URL}/convites-pendentes`)
    return r as unknown as ConvitePendente[]
  },

  /** Token novo para a mesma candidatura; o link anterior deixa de valer na hora. */
  reenviar: async (conviteId: string): Promise<ConviteEmitido> => {
    const r = await api.post<ConviteEmitido>(`${CONVITES_URL}/${conviteId}/reenviar`, {})
    return r as unknown as ConviteEmitido
  },
}
